export default function TokenExpireHandler(navigate, e) {
  if (e.response?.status == 401) {
    localStorage.clear()
    navigate('/')
  }
}
